import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { PARTYROLE, Region } from '../../../../model/region.model';
import { County } from '../../../../model/county';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Router } from '@angular/router';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { BaseLocalStorageService } from 'src/app/service/base-local-storage.service';
import { Observable } from 'rxjs/internal/Observable';
import { timer } from 'rxjs';
import { OrganizationService } from '../../../common-components/organizations/service/organization.service';
import { ORGANIZATION, School } from 'src/app/model/school.model';
import { UserProfileService } from '../../../user-profile/service/user-profile.service';
import { HelperService } from 'src/app/service/helper.service';
import { User } from '../../../auth/model/user.model';
import { CountyDropdownTwoWayComponent } from 'src/app/component/common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';
import { DistrictDropdownTwoWayComponent } from 'src/app/component/common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';
import { RegionDropdownTwoWayComponent } from 'src/app/component/common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';

@Component({
    selector: 'app-districts-location-layer',
    templateUrl: './districts-location-layer.component.html',
    styleUrls: ['./districts-location-layer.component.scss']
})
export class DistrictsLocationLayerComponent implements OnInit {
    @ViewChild(DistrictDropdownTwoWayComponent) child!: DistrictDropdownTwoWayComponent;
    @ViewChild(RegionDropdownTwoWayComponent) child2!: RegionDropdownTwoWayComponent;
    @ViewChild(CountyDropdownTwoWayComponent) child3!: CountyDropdownTwoWayComponent;
    @Input('showDistrictDropdown') showDistrictDropdown: boolean = true;

    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterRegioncode = new EventEmitter<Region[]>();

    formCtrl = new UntypedFormControl();
    myForm = new UntypedFormArray([new UntypedFormControl('', Validators.required)]);
    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';
    isLoadingResults = true;
    school: School;
    region!: Region;
    regions: Region[] = [];
    district!: SchoolDistrict;
    selectedSchoolDistrictId: number;
    selectedSchoolDistrictIds: number[];
    selectedCountyIds: number[];
    selectedRegionIds: number[];
    districts = [];
    promises: Array<any> = [];
    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;
    partyIdNum!: number;
    user: User = {};
    partyRoles: PARTYROLE[] = [];
    resetFieldRegions: boolean = false;
    resetFieldCounties: boolean = false;
    resetFieldDistricts: boolean = false;
    baseLocalStorageService: any;
    localStorageInfo$: Observable<any> = new Observable();
    checkedList: boolean[] = [];
    organizationService!: any;
	chosenRegions: Region[] = [];

    constructor(
        private router: Router,
        private store: Store<AppState>,
        _baseLocalStorageService: BaseLocalStorageService,
        private _organizationService: OrganizationService,
        private userProfileService: UserProfileService,
        private helperService: HelperService
    ) {
        this.region = new Region();
        // prep localStorage
        this.baseLocalStorageService = _baseLocalStorageService;
        this.localStorageInfo$ = _baseLocalStorageService.myData$;

        this.organizationService = _organizationService;
    }

    ngOnInit(): void {
        const timeSpinnerOut = setTimeout(() => {
            this.isLoadingResults = false;
        }, 7000);
        /*
        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.getPartyRoles();
            this.getRegionsByPartyId();
        });
*/
        // load party data
        /* this.organizationId = 3; // hardcode this for testing only

        this.organizationService.show(this.organizationId)
            .subscribe({
                next: (res: any) => {

                    this.myOrganization = res.organization;
                   // console.log("organization is: " + Object.entries(this.myOrganization));
                   // console.log("party ids are: " + this.myOrganization.PARTIES_ID)
                    this.partyId = this.myOrganization.PARTIES_ID;

                    this.partyIdNum = parseInt(this.partyId);                    

                   // console.log("inbound organization id1 is: " + this.organizationId);

                   // console.log("my organization: " + this.myOrganization.PARTIES_ID);

                },
                error: (err: any) => {
                    alert("Error while fetching the organization records");
                    console.log("error while getting organization data")
                }
            });
        */
        this.fnSetInitialData();
    }

    districtsSelected(districts: SchoolDistrict[]) {
        this.eventEmitterDistrictcode.emit(districts);
    }

    countiesSelected(counties: County[]) {
        this.eventEmitterCountycode.emit(counties);
    }

    regionsSelected(regions: Region[]) {
        this.eventEmitterRegioncode.emit(regions);
    }

    fnResetLocations() {
        let blankNumArray: number[] = [];
        let blankRegionsObj: Region[] = [];
        let blankCountiesObj: County[] = [];
        let blankDistrictsObj: SchoolDistrict[] = [];

        setTimeout(() => {
            /*   this.child2.selectedRegionIds = [];
            this.child2.select(blankNumArray);
            this.regionsSelected(blankRegionsObj);
            this.child2.reset = true; */
            this.child3.selectedCountyIds = [];
            this.child3.reset = true;
            this.child3.select(blankNumArray);
            this.countiesSelected(blankCountiesObj);
            this.child.select(blankNumArray);
            this.child.reset = true;
            this.districtsSelected(blankDistrictsObj);
        });

        try {
            this.checkedList = this.baseLocalStorageService?.getInfo('lastCheckedList');

            if (this.checkedList) {
                this.baseLocalStorageService.removeItem('lastCheckedList');
            }
        } catch (Err) {
            console.log('Error, but likely no localStorage yet for checkedLists:' + Err);
        }
    }

    reset() {
        //This is optional code To reset the value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetFieldRegions = !this.resetFieldRegions;
            this.resetFieldCounties = !this.resetFieldCounties;
            this.resetFieldDistricts = !this.resetFieldDistricts;
        });
        this.districts = [];
        this.child.selectedSchoolDistrictIds = [];
    }

    fnSetInitialData() {
        this.district = this.districts[0];
    }

    /*
    getPartyRoles() {
        console.log("getting party roles for user:" + Object.entries(this.user))
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log("got party roles:" + res.partyRoles)
            }
        });
    }

    getRegionsByPartyId() {
        //console.log("Setting regions by party id:")
        //console.log(this.user!.PERSON!.PARTy!.ID!)
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
                //console.log("regions now:");
                //console.log(Object.entries(this.regions[0]))

                this.region = this.regions[3];
                console.log("Setting regions in searchlocationlayer to:" + Object.entries(this.regions))
                // set region/county/district data+ Object.entries(thisRegion))
                this.helperService.setSelectedRegionObject(this.regions);
                this.helperService.selectedRegions$.forEach(x => console.log(x));

            }
        });
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }
    */
}
